import { totalSharesConfig } from '@/lib/analytics/kpis/youtube/totalShares';
import { SIZE_50 } from '@/lib/gridElements/size';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';

import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const mediaViewerSharesConfig: KpiType<typeof MediaViewerKpiLoader, typeof KPIDefault> = {
    ...totalSharesConfig,
    id: 'shares',
    size: SIZE_50,
    name: 'kpi.youtube.mediaviewer.shares',
    tooltip: null,
    loader: MediaViewerKpiLoader
};
